import styled from "styled-components";
import AreaSourceItem from "./AreaSourceItem";
import { PlaySource } from "type/panel/Panel.type";

type Props = {
  source: PlaySource[];
  onSourceDelete: Function;
  onSourceUpdate: Function;
};

const AreaSourceList = ({ source, onSourceDelete, onSourceUpdate }: Props) => {
  const sourceItemUpdateHandle = (
    sourceItemInd: number,
    sourceItem: PlaySource
  ) => {
    const nextSource: PlaySource[] = [...source];
    nextSource[sourceItemInd] = sourceItem;
    onSourceUpdate(nextSource);
  };

  const sourceItems: any = [];
  for (let i = source.length - 1; i >= 0; i--) {
    const sourceFields: PlaySource = source[i];
    sourceItems.push(
      <AreaSourceItem
        key={`source_item_${i}`}
        sourceItem={sourceFields}
        sourceItemInd={i}
        onSourceDelete={onSourceDelete}
        onSourceItemUpdate={sourceItemUpdateHandle}
      />
    );
  }
  return <>{source.length > 0 && <div>{sourceItems}</div>}</>;
};

export default AreaSourceList;
